export const environment = {
  debugApiResponse: false,
  production: false,
  apiUrl: 'https://dev-upgrade.service.3ddigitalvenue.com/api/v1',
  // apiUrl: 'https://pre-upgrades.service.3ddigitalvenue.com/api/v1',
  // apiUrl: 'https://upgrades.service.3ddigitalvenue.com/api/v1',
  stripePublicKey:
    'pk_test_51L0Lz4Jtl5swdMaxOYXDl02AytJoEVbAeol52Ddjq8svsOem4A4AIB14VDMxzUDdJJtvOxWHJtoQKse8FEtio9Lw000kJhVcNt',
  analytics: {
    club: [],
    mmc: '',
  },
};
